import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function usePlaylists(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPlaylists() {
      setLoading(true);
      const { response, data } = await API.fetchPlaylists(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    fetchPlaylists();
  }, [Object.values(filters).join("__")]);

  return {
    loading,
    playlists: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
